// import courseService from 'ApiService/Admin/courseService';
// import { AuthContext } from 'contexts/AuthContext';
// import { useContext, useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import SelectClass from './components/SelectClass';
// import studentService from 'ApiService/Admin/studentService';
// import StudentOverviewTable from './components/StudentOverviewTable';
// import jobServices from 'ApiService/Placement/jobServices';

// const Index = () => {
//   const [classData, setClassData] = useState({
//     courseId: '',
//     batchId: '',
//   });
//   const [loadingCourses, setLoadingCourses] = useState(true);
//   const [courses, setCourses] = useState([]);
//   const { state } = useContext(AuthContext);
//   const [selectedStandard, setSelectedStandard] = useState(null);
//   const [mcqData, setMcqData] = useState(null);
//   const [qaData, setQaData] = useState(null);
//   const [mcqAssignmentData, setAssignmentMcqData] = useState(null);
//   const [qaAssignmentData, setQaAssignmentData] = useState(null);
//   const [placementOverviewData, setPlacementOverviewData] = useState(null);

//   const [loadingStudentData, setLoadingStudentData] = useState(false);
//   const selectedBranch = state?.selectedBranch || '';

//   const fetchCourses = async () => {
//     setLoadingCourses(true);
//     try {
//       const response = await courseService.getCourseBatchInfo(selectedBranch);
//       if (response.data.success) {
//         setCourses(response.data.courses);
//       } else {
//         toast.error('Failed to fetch courses.');
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
//     } finally {
//       setLoadingCourses(false);
//     }
//   };

//   useEffect(() => {
//     fetchCourses();
//   }, [selectedBranch]);

//   const fetchAllData = async () => {
//     setLoadingStudentData(true);
//     try {
//       const practicalResponse = await studentService.getStudentOverview(
//         classData.batchId
//       );
//       if (practicalResponse.data.success) {
//         console.log(practicalResponse.data.Data, 'practicalResponse.data.data');
//         const sortedData = practicalResponse.data.Data.studentOverviews.sort(
//           (a, b) => a.name.localeCompare(b.name)
//         );
//         const withAttendance = await fetchAttendanceForStudents(sortedData);

//         practicalResponse.data.Data.studentOverviews = withAttendance;
//         setSelectedStandard({
//           ...practicalResponse.data.Data,
//           studentOverviews: withAttendance,
//         });
//       }

//       const mcqResponse = await studentService.getMcqTestOverview(
//         classData.batchId
//       );
//       if (mcqResponse.data.success) {
//         setMcqData(mcqResponse.data.data);
//       }

//       const qaResponse = await studentService.getQaTestOverview(
//         classData.batchId
//       );
//       if (qaResponse.data.success) {
//         setQaData(qaResponse.data.data);
//       }

//       //assignmnet
//       const mcqAssignmentResponse =
//         await studentService.getMCQAssignmentOverview(classData.batchId);
//       if (mcqAssignmentResponse.data.success) {
//         setAssignmentMcqData(mcqAssignmentResponse.data.data);
//       }

//       const qaAssignmentResponse = await studentService.getQAAssignmentOverview(
//         classData.batchId
//       );
//       if (qaAssignmentResponse.data.success) {
//         setQaAssignmentData(qaAssignmentResponse.data.data);
//       }
//       const placementResponce = await jobServices.getStudentWiseOverview(
//         classData.courseId,
//         classData.batchId
//       );
//       if (placementResponce.data.success) {
//         setPlacementOverviewData(placementResponce.data.data);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || 'Failed to fetch data');
//     } finally {
//       setLoadingStudentData(false);
//     }
//   };

//   useEffect(() => {
//     if (classData.batchId) {
//       fetchAllData();
//     }
//   }, [classData.batchId]);

// const fetchAttendanceForStudents = async (students) => {
//   try {
//     const studentIds = students.map(s => s.studentId);

//     const batchAttendanceRes = await studentService.getBatchAttendanceOverview({
//       course: classData.courseId,
//       batch: classData.batchId,
//       studentIds  // Send student IDs to backend
//     });

//     if (batchAttendanceRes.data?.success) {
//       // Create a map of studentId to attendance details
//       const attendanceMap = {};
//       batchAttendanceRes.data.studentAttendance.forEach(att => {
//         attendanceMap[att.studentId] = {
//           success: true,
//           totalLectures: batchAttendanceRes.data.totalLectures,
//           presentLectures: att.presentLectures,
//           absentLectures: att.absentLectures,
//           attendancePercentage: att.attendancePercentage,
//           absentDates: att.absentDates || []
//         };
//       });

//       // Merge attendance data with student data
//       return students.map(student => {
//         // For students with perfect attendance
//         if (!attendanceMap[student.studentId]) {
//           return {
//             ...student,
//             attendanceDetails: {
//               success: true,
//               totalLectures: batchAttendanceRes.data.totalLectures,
//               presentLectures: batchAttendanceRes.data.totalLectures,
//               absentLectures: 0,
//               attendancePercentage: 100.00
//             }
//           };
//         }

//         return {
//           ...student,
//           attendanceDetails: attendanceMap[student.studentId]
//         };
//       });
//     }
//   } catch (err) {
//     console.error('Batch attendance error:', err);
//   }

//   // Fallback to original student data
//   return students.map(student => ({
//     ...student,
//     attendanceDetails: null
//   }));
// };

//   return (
//     <div className="mt-3 flex h-full w-full flex-col gap-[20px] rounded-[20px]">
//       <div className="h-full w-full rounded-[20px]">
//         <SelectClass
//           setClassData={setClassData}
//           classData={classData}
//           courses={courses}
//           loadingCourses={loadingCourses}
//         />
//       </div>
//       <div className="h-full w-full rounded-t-2xl">
//         {selectedStandard && (
//           <StudentOverviewTable
//             data={selectedStandard}
//             mcqData={mcqData}
//             qaData={qaData}
//             mcqAssignmentData={mcqAssignmentData}
//             qaAssignmentData={qaAssignmentData}
//             isLoading={loadingStudentData}
//             placementOverviewData={placementOverviewData}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default Index;

import courseService from 'ApiService/Admin/courseService';
import studentService from 'ApiService/Admin/studentService';
import batchService from 'ApiService/Admin/batchService';
import jobServices from 'ApiService/Placement/jobServices';

import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { ThreeDots } from 'react-loader-spinner';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';

import Nodatafound from 'pages/Common/Nodatafound';

import SelectClass from './components/SelectClass';
import StudentOverviewTable from './components/StudentOverviewTable';

const Index = () => {
  /* ================= CLASS DATA ================= */
  const [classData, setClassData] = useState({
    courseId: '',
    batchStructureId: '',
    batchId: '',
  });

  /* ================= UI ================= */
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [loadingStudentData, setLoadingStudentData] = useState(false);

  /* ================= DATA ================= */
  const [courses, setCourses] = useState([]);
  const [batchStructures, setBatchStructures] = useState([]);

  const [selectedStandard, setSelectedStandard] = useState(null);
  const [mcqData, setMcqData] = useState(null);
  const [qaData, setQaData] = useState(null);
  const [mcqAssignmentData, setAssignmentMcqData] = useState(null);
  const [qaAssignmentData, setQaAssignmentData] = useState(null);
  const [placementOverviewData, setPlacementOverviewData] = useState(null);
  const [mockData, setMockData] = useState(null);
  const [finalMockData, setFinalMockData] = useState(null);

  /* ================= UNIVERSAL SEARCH ================= */
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [highlightStudentId, setHighlightStudentId] = useState(null);
  const [presetBatches, setPresetBatches] = useState([]);

  /* ================= AUTH ================= */
  const { state, loading } = useContext(AuthContext);

  const user = state?.user;
  const role = user?.role;
  const isSuperAdmin = role === 'superadmin';

  const selectedBranch = isSuperAdmin
    ? state?.selectedBranch
    : user?.branch?._id;

  /* ================= RESET ================= */
  const resetPage = () => {
    setClassData({
      courseId: '',
      batchStructureId: '',
      batchId: '',
    });
    setBatchStructures([]);
    setSelectedStandard(null);
    clearSearch();
  };

  /* ================= RESET ON BRANCH CHANGE ================= */
  useEffect(() => {
    if (!isSuperAdmin) return;
    if (!selectedBranch) return;
    resetPage();
  }, [selectedBranch, isSuperAdmin]);

  /* ================= SAFE FETCH COURSES ================= */
  useEffect(() => {
    const fetchCourses = async () => {
      setLoadingCourses(true);
      try {
        const res = await courseService.getAllCourses(selectedBranch);
        if (res.data.success) {
          setCourses(res.data.courses || []);
        }
      } catch {
        toast.error('Failed to fetch courses');
      } finally {
        setLoadingCourses(false);
      }
    };
    if (loading) return;
    if (!user) return;
    if (isSuperAdmin && !selectedBranch) return;

    fetchCourses();
  }, [loading, user, isSuperAdmin, selectedBranch]);

  /* ================= FETCH STRUCTURES ================= */
  const fetchBatchStructures = async (courseId) => {
    try {
      const res = await batchService.getBatchStructuresByCourse(
        courseId,
        selectedBranch
      );
      setBatchStructures(res?.data?.batchStructures || []);
    } catch {
      toast.error('Failed to fetch batch structures');
      setBatchStructures([]);
    }
  };

  /* ================= FETCH BATCHES ================= */
  const fetchBatchesByStructure = async (structureId) => {
    try {
      const res = await batchService.getBatchesByBatchStructure(
        structureId,
        selectedBranch
      );
      return res?.data?.batches || [];
    } catch {
      toast.error('Failed to fetch batches');
      return [];
    }
  };

  /* ================= AUTO FETCH WHEN ALL SELECTED ================= */
  useEffect(() => {
    const fetchAllData = async () => {
      setLoadingStudentData(true);
      try {
        const practicalResponse = await studentService.getStudentOverview(
          classData.batchId
        );

        if (practicalResponse.data.success) {
          const sortedStudents =
            practicalResponse.data.Data.studentOverviews.sort((a, b) =>
              a.name.localeCompare(b.name)
            );

          practicalResponse.data.Data.studentOverviews = sortedStudents;
          setSelectedStandard(practicalResponse.data.Data);
        }

        const mcqResponse = await studentService.getMcqTestOverview(
          classData.batchId
        );
        if (mcqResponse.data.success) setMcqData(mcqResponse.data.data);

        const qaResponse = await studentService.getQaTestOverview(
          classData.batchId
        );
        if (qaResponse.data.success) setQaData(qaResponse.data.data);

        const mcqAssignmentResponse =
          await studentService.getMCQAssignmentOverview(classData.batchId);
        if (mcqAssignmentResponse.data.success)
          setAssignmentMcqData(mcqAssignmentResponse.data.data);

        const qaAssignmentResponse = await studentService.getQAAssignmentOverview(
          classData.batchId
        );
        if (qaAssignmentResponse.data.success)
          setQaAssignmentData(qaAssignmentResponse.data.data);

        const placementResponse = await jobServices.getStudentWiseOverview(
          classData.courseId,
          classData.batchId
        );
        if (placementResponse.data.success)
          setPlacementOverviewData(placementResponse.data.data);

        const mockResponse = await studentService.getExternalPracticeOverview(
          classData.batchId
        );
        if (mockResponse.data.success) setMockData(mockResponse.data.data);

        const finalMockResponse = await studentService.getExternalMockOverview(
          classData.batchId
        );
        if (finalMockResponse.data.success)
          setFinalMockData(finalMockResponse.data.data);
      } catch {
        toast.error('Failed to fetch data');
      } finally {
        setLoadingStudentData(false);
      }
    };
    if (classData.courseId && classData.batchStructureId && classData.batchId) {
      fetchAllData();
    }
  }, [classData]);

  /* ================= UNIVERSAL SEARCH HANDLERS ================= */
  const handleSearchStudents = async () => {
    const q = searchQuery.trim();
    if (!q || q.length < 2) {
      toast.error('Enter at least 2 characters to search');
      return;
    }
    setSearchLoading(true);
    setShowSearchResults(true);
    try {
      const res = await studentService.searchStudents(q);
      setSearchResults(res.data?.data || []);
    } catch {
      toast.error('Search failed');
      setSearchResults([]);
    } finally {
      setSearchLoading(false);
    }
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') handleSearchStudents();
  };

  const handleStudentClick = async (student) => {
    const enrollment = student.enrollments?.[0];
    if (
      !enrollment?.course?._id ||
      !enrollment?.batch?._id ||
      !enrollment?.batchStructure
    ) {
      toast.error('No active enrollment found for this student');
      return;
    }

    setClassData({
      courseId: enrollment.course._id,
      batchStructureId: enrollment.batchStructure,
      batchId: enrollment.batch._id,
    });
    setHighlightStudentId(student._id);

    fetchBatchStructures(enrollment.course._id);
    const fetchedBatches = await fetchBatchesByStructure(
      enrollment.batchStructure
    );
    setPresetBatches(fetchedBatches || []);
  };

  const clearSearch = () => {
    setSearchQuery('');
    setSearchResults([]);
    setShowSearchResults(false);
    setHighlightStudentId(null);
    setPresetBatches([]);
  };

  /* ================= LOADERS ================= */
  if (loading) {
    return (
      <div className="flex h-60 items-center justify-center">
        Loading user...
      </div>
    );
  }

  const branchNotSelected = isSuperAdmin && !selectedBranch;

  return (
    <div className="mt-10 h-full w-full">
      {/* ================= UNIVERSAL SEARCH — always on top ================= */}
      <div className="mx-auto w-[95%] md:px-3 3xl:w-7/12">
        <div className="mb-4 rounded-lg border border-brand-200 bg-brand-50 p-4 dark:border-navy-600 dark:bg-navy-700">
          <h4 className="mb-3 text-center text-lg font-bold">
            Universal Student Search
          </h4>
          <p className="mb-3 text-center text-sm text-gray-500">
            Search across all students by Name, Email, or Mobile Number
          </p>
          <div className="flex items-center gap-3">
            <input
              type="text"
              placeholder="Search by Name, Email, or Mobile Number..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={handleSearchKeyDown}
              className="block w-full rounded-xl border border-gray-300 bg-white p-3 text-sm outline-none focus:border-brand-500 dark:border-navy-500 dark:bg-navy-800 dark:text-white"
            />
            <button
              onClick={handleSearchStudents}
              disabled={searchLoading}
              className="linear cursor-pointer rounded-xl bg-brand-900 px-6 py-3 font-medium text-white transition duration-200 hover:bg-brand-800 disabled:opacity-60 dark:bg-brand-400 dark:hover:bg-brand-300"
            >
              {searchLoading ? 'Searching...' : 'Search'}
            </button>
            {showSearchResults && (
              <button
                onClick={clearSearch}
                className="linear cursor-pointer rounded-xl bg-gray-200 px-4 py-3 font-medium text-gray-700 transition duration-200 hover:bg-gray-300 dark:bg-navy-600 dark:text-white dark:hover:bg-navy-500"
              >
                Clear
              </button>
              )}
            </div>

            {showSearchResults && (
            <div className="mt-4">
              {searchLoading ? (
                <div className="flex justify-center py-8">
                  <ThreeDots color="#5431ed" />
                </div>
              ) : searchResults.length === 0 ? (
                <Nodatafound title="No students found matching your search" />
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead>
                      <tr>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white">
                          Sr No
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white">
                          Name
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white">
                          Email
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white">
                          Contact Number
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white">
                          Gender
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchResults.map((student, index) => (
                        <tr
                          key={student._id}
                          onClick={() => handleStudentClick(student)}
                          className="cursor-pointer hover:bg-gray-50 dark:hover:bg-navy-600"
                        >
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-gray-700 dark:text-white">
                            {index + 1}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-gray-700 dark:text-white">
                            {student.name}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm text-gray-700 dark:text-white">
                            {student.email}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm text-gray-700 dark:text-white">
                            {student.contactNumber}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm text-gray-700 dark:text-white">
                            {student.gender}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <p className="mt-2 text-center text-xs text-gray-400">
                    Showing up to 50 results. Click a row to view details.
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {branchNotSelected ? (
        <div className="flex h-40 items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 mx-auto w-[95%] md:px-3 3xl:w-7/12">
          <p className="text-sm text-gray-500">
            Select a branch to view class data
          </p>
        </div>
      ) : (
        <>
          <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600" />

          <div className="mx-auto h-full w-[95%] md:px-3 lg:mt-5 3xl:w-7/12">
            <Card extra="-mt-[280px] w-full md:-mt-[340px] md:px-[70px] p-3">
              <UseContextProvider>
                <SelectClass
                  classData={classData}
                  setClassData={setClassData}
                  courses={courses}
                  batchStructures={batchStructures}
                  fetchBatchStructures={fetchBatchStructures}
                  fetchBatchesByStructure={fetchBatchesByStructure}
                  loadingCourses={loadingCourses}
                  presetBatches={presetBatches}
                />

                {selectedStandard && (
                  <StudentOverviewTable
                    data={selectedStandard}
                    mcqData={mcqData}
                    qaData={qaData}
                    mcqAssignmentData={mcqAssignmentData}
                    qaAssignmentData={qaAssignmentData}
                    placementOverviewData={placementOverviewData}
                    mockData={mockData}
                    finalMockData={finalMockData}
                    isLoading={loadingStudentData}
                    highlightStudentId={highlightStudentId}
                  />
                )}
              </UseContextProvider>
            </Card>
          </div>
        </>
      )}
    </div>
  );
};

export default Index;
